import React, { useState } from "react";
import { Modal, StyleSheet, Text, View } from "react-native";
import FeatherIcon from "react-native-vector-icons/Feather";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import Button from "./Button";
import * as Colors from "../styles/colors";
import * as Fonts from "../styles/typography";
import ButtonIcon from "./ButonIcon";

export default function FractionAmount({
    modalVisible,
    setModalVisible,
    onPress
}) {
    const [fractionAmount, setFractionAmount] = useState(1)
    return (
        <Modal
            animationType="fade"
            transparent={true}
            style={{ backgroundColor: "#000" }}
            visible={modalVisible.show}
            onRequestClose={() => setModalVisible({show: !modalVisible.show, fractionId: 0})}
        >
            <View style={styles.centeredView}>
                <View style={styles.modalView}>
                    <Icon
                        name="close"
                        size={32}
                        onPress={() => {
                            setFractionAmount(1)
                            setModalVisible({show: !modalVisible.show, fractionId: 0})
                        }}
                        style={styles.closeButton}
                    />
                    <View style={styles.titleView}>
                        <FeatherIcon size={32} name="pie-chart" />
                        <Text style={styles.titleText}>{"Fração"}</Text>
                    </View>
                    <View style={styles.subTitleView}>
                        <Text style={styles.subTitleText}>
                            {
                                "Informe a quantidade de frações."
                            }
                        </Text>
                        <View style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginVertical: 16 }}>
                            <ButtonIcon iconName={"minus-thick"}
                                size={20}
                                colorButton={Colors.ALERT} style={{ marginRight: 32, borderRadius: 64 }}
                                onPress={() => setFractionAmount(fractionAmount > 1 ? fractionAmount - 1 : 1)} />
                            <Text style={styles.amountText}>{fractionAmount}</Text>
                            <ButtonIcon iconName={"plus-thick"}
                                size={20}
                                colorButton={Colors.ALERT}
                                style={{ marginLeft: 32, borderRadius: 64 }}
                                onPress={() => setFractionAmount(fractionAmount + 1)} />
                        </View>
                    </View>
                    <View style={styles.viewButton}>
                        <Button
                            textoBotao={"Confirmar"}
                            estilo={{ backgroundColor: Colors.SUCCESS }}
                            onPress={() => {
                                setModalVisible({show: !modalVisible.show, fractionId: modalVisible.fractionId })
                                onPress(fractionAmount)
                                setFractionAmount(1)
                            }}
                        />
                    </View>
                </View>
            </View>
        </Modal>
    );
}

const styles = StyleSheet.create({
    centeredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0,0,0,0.5)",
    },
    titleView: {
        marginBottom: 8,
        alignItems: "center",
    },
    titleText: {
        textAlign: "center",
        fontSize: Fonts.FONT_SIZE_20,
        fontWeight: "bold",
    },
    subTitleView: {
        alignItems: "center",
        width: "90%",
    },
    subTitleText: {
        textAlign: "center",
        fontSize: Fonts.FONT_SIZE_16,
        color: Colors.GRAY_DARK,
    },
    modalView: {
        margin: 20,
        backgroundColor: Colors.WHITE,
        borderRadius: 8,
        padding: 16,
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
    },
    closeButton: {
        marginLeft: "auto",
        color: Colors.GRAY_DARK,
    },
    viewButton: {
        marginTop: 16,
    },
    amountText: {
        fontSize: Fonts.FONT_SIZE_24,
        color: Colors.BLACK,
        fontWeight: "500"
    }
});
